const transactions = {
  transactions: `Transactions`,
  transaction: `Transaction`,
  no_transactions_found: `No transactions found`,
  sent_money_to: `Sent money to`,
  received_money_from: `Received money from`,
  transactedAt: `Transacted at`,
  not_available_testing_mode: `Not available in testing mode`,
  gateway_not_connected: `Payment gateway not connected`,
  transacted_by: `Transacted by`,
  transacted_on: `Transacted on`,
  status: `Status`,
  received: `Received`,
  sent: `Sent`,
  BankTransfer: `Bank transfer`,
  processed_by_and_date: `Processed by & date`,
  transaction_type: `Transaction type`,
  debit: `Debit`,
  credit: `Credit`,
  delete_transaction_warning: `Deleted transaction cannot be recovered`,
  delete_transaction: `Are you sure you want to delete this transaction`,
  deactive_not_allowed: `Deactivation not allowed`,
  transaction_deleted_successfully: `Transaction deleted successfully`,
  actions: `Actions`,
};
export default transactions;
